import { SelfTestOption, selfTests } from '@casops/config';
import { ObjectType } from '@casops/store/apis/commonModels';
import { TFunction } from 'i18next';

export const getSelfTestCategoryIds = () => Array.from({ length: 13 }, (_, i) => i + 1);

// Fixme: Translations missing.
export const getSelfTestCategory = (t: TFunction, category?: number): string => {
  switch (category) {
    case 1:
      return t('FaultCategoryDisplay');
    case 2:
      return t('FaultCategoryIvu');
    case 3:
      return t('FaultCategoryGps');
    case 4:
      return t('FaultCategoryV2V');
    case 5:
      return t('FaultCategoryAudio');
    case 6:
      return t('FaultCategoryConn');
    case 7:
      return t('FaultCategoryMemory');
    case 8:
      return t('FaultCategoryCamera');
    case 9:
      return t('FaultCategoryLfm');
    case 10:
      return t('FaultCategoryInput');
    case 11:
      return t('FaultCategoryNetwork');
    case 12:
      return t('FaultCategoryConfig');
    case 13:
      return t('FaultCategoryL9');
    default:
      return t('Unknown');
  }
};

// Fixme: Translations missing.
export const getComponentName = (t: TFunction, value: string, hwType?: string): string => {
  const isLV = hwType === 'X1' || hwType === 'X9';

  switch (value) {
    case 'MainBoard':
      return t('ComponentInVehicleUnit');
    case 'X9':
      return t('X9');
    case 'Display':
      return t('Display');
    case 'GPS':
      return t('ComponentGPS');
    case 'Hub':
      return t('ComponentHub');
    case 'PCU':
      return t('PCU');
    case 'PrimaryNode':
      return isLV ? t('ComponentPrimaryICU') : t('ComponentPrimaryNode');
    case 'SecondaryNode':
      return isLV ? t('ComponentSelfTestICU') : t('ComponentSelfTestNode');
    case 'LFMFront':
      return t('LFM Front');
    case 'LFMRear':
      return t('LFM Rear');
    case 'ExpansionUnit':
      return t('Expansion Unit');
    case 'CamRfFront':
      return t('CAM RF Front');
    case 'CamRfRear':
      return t('CAM RF Rear');
    case 'CamRfLeft':
      return t('CAM RF Left');
    case 'CamRfRight':
      return t('CAM RF Right');
    case 'CamRfTop':
      return t('CAM RF Top');
    case 'RadioUnit':
      return t('ComponentRadioUnit');
    case 'ToF1':
      return t('TOF 1');
    case 'ToF2':
      return t('TOF 2');
    case 'V2V':
      return t('ComponentV2V');
    case 'UMS':
      return t('UMS');
    case 'Termux':
      return t('TermUX');
    default:
      return value;
  }
};

// Fixme: Translations missing.
export const getSelfTestName = (t: TFunction, selfTestId?: number): string => {
  const selfTest: SelfTestOption | undefined = selfTests.find(
    (s: SelfTestOption) => s[0] === selfTestId,
  );
  return selfTest ? t(`FaultTest_${selfTest[0]}`) : t('Unknown');
};

export const getObjectTypeFromEnum = (t: TFunction, objectType: ObjectType): string => {
  return t(`ObjType.${objectType}`);
};
